const goldStarsKeys = {
  all: ['gold_stars'],
  changes: (companyId?: string, month?: string, year?: string) => [
    ...goldStarsKeys.all,
    'changes',
    companyId,
    month,
    year,
  ],
}

export default goldStarsKeys
